import { Z_INDEX } from './z-index';

export const ClutterlessTheme = {
  '.entity-chat-panel-overlay': {
    zIndex: `${Z_INDEX.MESSAGE_SIDEBAR_BACKDROP} !important`,
    isolation: 'isolate !important',
    position: 'fixed !important'
  },
  '.entity-chat-panel-base': {
    zIndex: `${Z_INDEX.MESSAGE_SIDEBAR_CONTENT} !important`,
    isolation: 'isolate !important',
    position: 'fixed !important',
    backgroundColor: '#ffffff'
  },
  '.entity-chat-floating-button': {
    right: '70px !important',
    bottom: '10px !important'
  },
  '[data-radix-popper-content-wrapper]': {
    zIndex: '600 !important'
  },
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '0px',
  boxShadow: 'none',
  color: '#1a1a1a',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  '& .entity-chat-panel-header': {
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e1e5e9',
    borderRadius: '0',
    color: '#2d3748',
    padding: '6px 16px',
    minHeight: 'auto'
  },
  '& .entity-chat-panel-filter-label': {
    display: 'none'
  },
  '& .entity-chat-panel-tabs-container': {
    backgroundColor: '#ffffff',
    padding: '0'
  },
  '& .entity-chat-panel-tabs-list': {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    padding: '0 16px',
    gap: '0'
  },
  '& .entity-chat-panel-tab': {
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '2px solid transparent',
    borderRadius: '0',
    padding: '4px 12px',
    fontSize: '14px',
    fontWeight: '500',
    '&[data-state="active"]': {
      backgroundColor: 'transparent',
      color: '#1f2937',
      borderBottomColor: '#3b82f6',
      fontWeight: '600'
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#374151'
    }
  },
  '& .entity-chat-panel-messages': {
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    padding: '0'
  },
  '& .entity-chat-panel-message': {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '0',
    marginBottom: '0',
    // No horizontal padding: the redesigned card (.entity-chat-panel-message-thread) owns it, so the
    // old 16px stacked on top and pushed the avatar in. Vertical only.
    padding: '2px 0',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: '#f8f9fa'
    }
  },
  '& .entity-chat-panel-message-content': {
    fontSize: '16px',
    lineHeight: '1.4',
    color: '#000000',
    fontWeight: '400',
    margin: '1px 0 0 0',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    textAlign: 'left !important',
    display: 'block',
    width: '100%'
  },
  '& .entity-chat-panel-message-author': {
    fontSize: '11px',
    fontWeight: '400',
    color: '#9ca3af',
    marginBottom: '0px'
  },
  '& .entity-chat-panel-message-time': {
    fontSize: '10px',
    color: '#d1d5db',
    fontWeight: '400',
    paddingInline: '4px'
  },
  '& .entity-chat-panel-message-avatar': {
    width: '24px',
    height: '24px',
    fontSize: '10px',
    backgroundColor: '#f3f4f6',
    color: '#9ca3af',
    border: 'none'
  },
  '& .entity-chat-panel-input-area': {
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e1e5e9',
    padding: '6px 16px'
  },
  '& .entity-chat-panel-textarea': {
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '14px',
    padding: '8px 12px',
    textAlign: 'left !important',
    '&::placeholder': {
      color: '#9ca3af'
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6'
    }
  },
  '& .entity-chat-panel-textarea input': {
    textAlign: 'left !important'
  },
  '& .entity-chat-panel-textarea textarea': {
    textAlign: 'left !important'
  },
  '& .tiptap-html-editor-wrapper': {
    backgroundColor: '#ffffff'
  },
  '& .tiptap-html-editor-container': {
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '6px'
  },
  '& .tiptap-html-editor-toolbar': {
    backgroundColor: '#f9fafb',
    border: 'none',
    borderBottom: '1px solid #e5e7eb',
    padding: '6px 8px'
  },
  '& .tiptap-html-editor-input-wrapper .dx-htmleditor-content': {
    color: '#1a1a1a',
    backgroundColor: '#ffffff',
    fontSize: '14px'
  },
  '& .tiptap-html-editor-button': {
    color: '#6b7280',
    width: '28px',
    height: '28px',
    padding: '4px',
    '&:hover': {
      color: '#374151',
      backgroundColor: '#e5e7eb'
    }
  },
  '& .tiptap-html-editor-send-button': {
    backgroundColor: '#3b82f6',
    borderRadius: '4px',
    color: 'white',
    border: 'none',
    width: '28px',
    height: '28px',
    padding: '4px',
    '&:hover': {
      backgroundColor: '#2563eb'
    }
  },
  '& .entity-chat-panel-send-button': {
    backgroundColor: '#3b82f6',
    borderRadius: '4px',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#2563eb'
    }
  },
  '& .entity-chat-panel-empty': {
    color: '#9ca3af',
    fontSize: '14px',
    padding: '16px 16px'
  },
  '& .entity-chat-panel-reply-message, & .entity-chat-panel-reply-input-area': {
    background: '#f8f9fa',
    borderLeftColor: '#d1d5db',
    borderLeft: '3px solid #d1d5db',
    margin: '1px 0 1px 32px',
    padding: '4px 12px',
    borderRadius: '0'
  },
  '& .entity-chat-panel-reply-button': {
    color: '#6b7280',
    fontSize: '11px',
    padding: '1px 6px',
    borderRadius: '3px',
    border: '1px solid #e5e7eb',
    backgroundColor: 'transparent',
    fontWeight: '400',
    '&:hover': {
      color: '#374151',
      backgroundColor: '#f3f4f6',
      borderColor: '#d1d5db'
    }
  },
  '& .entity-chat-panel-reply-textarea': {
    background: '#ffffff',
    color: '#1a1a1a',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    fontSize: '13px',
    padding: '4px 8px',
    textAlign: 'left !important',
    '&::placeholder': {
      color: '#9ca3af'
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6'
    }
  },
  '& .entity-chat-panel-reply-textarea input': {
    textAlign: 'left !important'
  },
  '& .entity-chat-panel-reply-textarea textarea': {
    textAlign: 'left !important'
  },
  '& .entity-chat-panel-reply-send': {
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '2px 6px',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: '#2563eb'
    }
  },
  '& .entity-chat-panel-thread-badge': {
    background: '#f3f4f6',
    color: '#6b7280',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    fontSize: '10px',
    padding: '1px 4px'
  },
  // Override the main spacing culprits
  '& .entity-chat-panel-messages > * + *': {
    marginTop: '2px'
  },
  '& .entity-chat-panel-thread-reply-section': {
    marginTop: '1px',
    paddingRight: '16px'
  },
  // Very subtle entity pills for clutterless theme - barely noticeable
  '& .entity-chat-panel-message-entity-pill': {
    borderRadius: '3px',
    fontSize: '9px',
    fontWeight: '400',
    padding: '1px 4px',
    opacity: '0.6',
    border: 'none'
  },
  '& .entity-chat-panel-message-entity-workorder-pill': {
    backgroundColor: '#f0fdf4', // very light green
    color: '#65a30d'
  },
  '& .entity-chat-panel-message-entity-contact-pill': {
    backgroundColor: '#fffbeb', // very light amber
    color: '#d97706'
  },
  '& .entity-chat-panel-message-entity-organization-pill': {
    backgroundColor: '#faf5ff', // very light purple
    color: '#9333ea'
  },
  '& .entity-chat-panel-message-entity-timesheet-pill': {
    backgroundColor: '#f1f5f9', // very light blue-gray
    color: '#64748b'
  },
  '& .entity-chat-panel-message-entity-expense-pill': {
    backgroundColor: '#fef2f2', // very light red
    color: '#dc2626'
  },
  // Additional text alignment rules for all input elements
  '& input[type="text"], & input[type="email"], & textarea, & [contenteditable="true"]': {
    textAlign: 'left !important'
  },
  '& .entity-chat-panel input, & .entity-chat-panel textarea': {
    textAlign: 'left !important'
  },
  // Left-align the message TEXT only. The previous rule set `display:block; width:100%` on every
  // span/div inside a message, which flattened the redesigned card's avatar (a span) and stacked the
  // author/time header — that was the "avatar not aligned / WFH differs from FBO" report. Scoping to
  // the text block leaves the avatar and header laid out by their own flex rules, and drops the badge
  // patch that only existed to undo the blanket rule.
  '& .entity-chat-panel-message-text, & .entity-chat-panel-message-text *': {
    textAlign: 'left'
  }
}